/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `requested` - Awaiting host acceptance
 * * `declined` - Declined by host
 * * `pending` - Pending
 * * `challenged` - Challenged
 * * `confirmed` - Confirmed
 * * `standby` - Standby
 * * `released` - Released
 * * `expired` - Expired
 * * `cancelled` - Cancelled
 * @export
 */
export const StatusAb7Enum = {
    Requested: 'requested',
    Declined: 'declined',
    Pending: 'pending',
    Challenged: 'challenged',
    Confirmed: 'confirmed',
    Standby: 'standby',
    Released: 'released',
    Expired: 'expired',
    Cancelled: 'cancelled'
} as const;
export type StatusAb7Enum = typeof StatusAb7Enum[keyof typeof StatusAb7Enum];


export function instanceOfStatusAb7Enum(value: any): boolean {
    for (const key in StatusAb7Enum) {
        if (Object.prototype.hasOwnProperty.call(StatusAb7Enum, key)) {
            if (StatusAb7Enum[key as keyof typeof StatusAb7Enum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function StatusAb7EnumFromJSON(json: any): StatusAb7Enum {
    return StatusAb7EnumFromJSONTyped(json, false);
}

export function StatusAb7EnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatusAb7Enum {
    return json as StatusAb7Enum;
}

export function StatusAb7EnumToJSON(value?: StatusAb7Enum | null): any {
    return value as any;
}

export function StatusAb7EnumToJSONTyped(value: any, ignoreDiscriminator: boolean): StatusAb7Enum {
    return value as StatusAb7Enum;
}
